/**
 * 모델
 * @window w_tb_e050
 * @category 유지관리매출생성
 */
import { computed } from 'mobx';

export class MaintenanceModel {
  /**
   * 사업장코드
   *
   * **data type** varchar(2)
   */
  readonly spjangcd: string;

  /**
   * 삭제
   *
   * **data type** varchar(1)
   */
  chk: string;

  /**
   * 회사코드
   *
   * **data type** char(8)
   */
  custcd: string;

  /**
   * 연결코드
   *
   * **data type** varchar(13)
   */
  cltcd: string;

  /**
   * 사업자등록번호
   *
   * **data type** varchar(13)
   */
  saupnum: string;

  /**
   * 0
   *
   * **data type** varchar(1)
   */
  misgubun: string;

  /**
   * 매출일자
   *
   * **data type** varchar(8)
   */
  misdate: string;

  /**
   * 번호
   *
   * **data type** varchar(4)
   */
  misnum: string;

  /**
   * 지로번호
   *
   * **data type** varchar(10)
   */
  pubnum: string;

  /**
   * 현장명
   *
   * **data type** varchar(255)
   */
  actnm: string;

  /**
   * 회사구분코드
   *
   * **data type** varchar(3)
   */
  wkactcd: string;

  /**
   * 회사구분
   *
   * **data type** varchar(100)
   */
  wkactnm: string;

  /**
   * 계약금액
   *
   * **data type** number
   */
  contamt: string;

  /**
   * 매출분류
   *
   * **data type** varchar(3)
   */
  gubun: string;

  /**
   * 귀속년월
   *
   * **data type** varchar(6)
   */
  yyyymm: string;

  /**
   * 회계적용
   *
   * **data type** varchar(1)
   */
  accyn: string;

  /**
   * 매출액
   *
   * **data type** number
   */
  amt: string;

  /**
   * 부가세
   *
   * **data type** number
   */
  addamt: string;

  /**
   * 합계
   *
   * **data type** number
   */
  misamt: string;

  /**
   * 현대금액
   *
   * **data type** number
   */
  hdamt: string;

  /**
   * 발행구분
   *
   * **data type** varchar(1)
   */
  billgubun: string;

  /**
   * 계산서발행
   *
   * **data type** varchar(2)
   */
  billkind: string;

  /**
   * 부가세여부
   *
   * **data type** varchar(2)
   */
  taxcls: string;

  /**
   * 과세구분
   *
   * **data type** varchar(3)
   */
  taxgubun: string;

  /**
   * 지로구분
   *
   * **data type** varchar(1)
   */
  jirogubun: string;

  /**
   * 계산서일자
   *
   * **data type** varchar(8)
   */
  tax_spdate: string;

  /**
   * 번호
   *
   * **data type** varchar(4)
   */
  tax_spnum: string;

  /**
   * 전표일자
   *
   * **data type** varchar(8)
   */
  acc_spdate: string;

  /**
   * 번호
   *
   * **data type** varchar(4)
   */
  acc_spnum: string;

  /**
   * 적요
   *
   * **data type** varchar(255)
   */
  remark: string;

  /**
   * 상태
   *
   * **data type** varchar(2)
   */
  recivstatus: string;

  /**
   * 지로출력
   *
   * **data type** varchar(1)
   */
  prtchk: string;

  /**
   * 입력일
   *
   * **data type** varchar(8)
   */
  indate: string;

  /**
   * 입력자
   *
   * **data type** varchar(10)
   */
  inperid: string;

  /**
   * 현장코드
   *
   * **data type** varchar(15)
   */
  actcd: string;

  /**
   * 거래처명
   *
   * **data type** varchar(15)
   */
  cltnm: string;

  new: string;

  constructor(data: any = {}, isNew: boolean = false) {
    this.chk = data.chk || '';
    this.spjangcd = data.spjangcd || '';
    this.cltnm = data.cltnm || '';
    this.custcd = data.custcd || '';
    this.cltcd = data.cltcd || '';
    this.saupnum = data.saupnum || '';
    this.misgubun = data.misgubun || '';
    this.misdate = data.misdate || '';
    this.misnum = data.misnum || '';
    this.pubnum = data.pubnum || '';
    this.actcd = data.actcd || '';
    this.actnm = data.actnm || '';
    this.wkactcd = data.wkactcd || '';
    this.wkactnm = data.wkactnm || '';
    this.contamt = data.contamt || '';
    this.gubun = data.gubun || '';
    this.yyyymm = data.yyyymm || '';
    this.accyn = data.accyn || '';
    this.amt = data.amt || '';
    this.addamt = data.addamt || '';
    this.misamt = data.misamt || '';
    this.hdamt = data.hdamt || '';
    this.billgubun = data.billgubun || '';
    this.billkind = data.billkind || '';
    this.taxcls = data.taxcls || '';
    this.taxgubun = data.taxgubun || '';
    this.jirogubun = data.jirogubun || '';
    this.tax_spdate = data.tax_spdate || '';
    this.tax_spnum = data.tax_spnum || '';
    this.acc_spdate = data.acc_spdate || '';
    this.acc_spnum = data.acc_spnum || '';
    this.remark = data.remark || '';
    this.recivstatus = data.recivstatus || '';
    this.prtchk = data.prtchk || '';
    this.indate = data.indate || '';
    this.inperid = data.inperid || '';
    this.new = isNew ? '1' : '0';
  }

  @computed
  get isNew() {
    return this.new === '1';
  }

  updateChk(chk: string) {
    this.chk = chk;
    return this;
  }
}
